module.exports = __webpack_public_path__ + "static/media/fa-solid-900.3b944a15.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/webfonts/fa-solid-900.woff2
// module id = 881
// module chunks = 0